import { API } from "../lib/api";
import { ShareButtons } from "./ShareButtons";

export const CallShare = ({ c, full }) => (
  <ShareButtons
    title={full ? "Share this casting call" : ""}
    shareUrl={`${API}/share/casting/${c.id}`}
    copyUrl={`${window.location.origin}/casting-calls/${c.id}`}
    text={`Extras wanted: ${c.production_title || `${c.extras_needed} extras`} in ${c.location} – via extras.tv`}
    only={full ? null : ["whatsapp", "facebook"]}
    testPrefix={`call-share-${c.id}`}
  />
);
